import React from 'react'
import { Box, Typography } from '@mui/material'
import AdxPdfImageViewer from '../AdxPdfImageViewer'
import AdxButton from 'components/custom/AdxButton'

// This functions will be revisited later once documents upload is set.
const AdxFileAttachmentLeave = ({ item = { name: 'Sample document', url: null } }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100px',
        boxSizing: 'border-box',
        backgroundColor: 'gray-background.main',
        borderRadius: '4.5px',
        display: 'flex',
        alignItems: 'center',
        px: 2,
        columnGap: 2,
      }}
    >
      <Box width="50px" height="50px">
        <AdxPdfImageViewer fileUrl={item.url} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 1,
        }}
      >
        <Typography variant="body1" color="dark-text.main">
          {item?.name}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <AdxButton
            variant={'outlined'}
            size={'tiny'}
            onClick={() => window.open(item.url, '_blank')}
          >
            View
          </AdxButton>
          <AdxButton variant={'outlined'} size={'tiny'} href={item.url} target="_blank" download>
            Download
          </AdxButton>
        </Box>
      </Box>
    </Box>
  )
}

export default AdxFileAttachmentLeave
